<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<h4>基本信息</h4>
			</div>
			<el-descriptions title="" :column="1" border>
				<el-descriptions-item label="用户昵称">{{detailObject.name}}</el-descriptions-item>
				<el-descriptions-item label="用户手机号">{{detailObject.phone}}</el-descriptions-item>
				<el-descriptions-item label="用户企业">{{detailObject.business_name?detailObject.business_name:detailObject.business}}</el-descriptions-item>
				<el-descriptions-item label="用户会员等级">{{detailObject.member_name}}</el-descriptions-item>
				<el-descriptions-item label="会员到期时间">{{detailObject.member_time}}</el-descriptions-item>
				<el-descriptions-item label="用户注册时间">{{detailObject.create_time}}</el-descriptions-item>
				<el-descriptions-item label="用户最近登陆时间">{{detailObject.last_login_time}}</el-descriptions-item>
				<el-descriptions-item label="用户累计登陆天数">{{detailObject.login_day}}</el-descriptions-item>
				<el-descriptions-item label="现有机型">{{detailObject.phone_type}}</el-descriptions-item>
				<el-descriptions-item label="头像">
					<img :src="detailObject.img" style="width: 80px;height: 80px;border-radius: 50%;" />
				</el-descriptions-item>
			</el-descriptions>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<h4>拉新情况</h4>
			</div>
			<el-table :data="inviteTable" border class="table-wrap"
				:header-cell-style="{background:'#eef1f6',color:'#606266'}" style="width: 100%">
				<el-table-column prop="phone" label="用户手机号" align="center">
				</el-table-column>
				<el-table-column prop="name" label="用户昵称" align="center">
				</el-table-column>
				<el-table-column prop="create_time" label="注册时间" align="center">
				</el-table-column>
				<el-table-column prop="last_login_time" label="最近登陆时间" align="center">
				</el-table-column>
			</el-table>
			<div class="flex flex-b" style="padding: 10px 30px;">
				<h4>总计</h4>
				<h4>{{inviteTotal}}人</h4>
			</div>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<h4>已购课程</h4>
			</div>
			<el-collapse v-model="activeName" accordion>
				<el-collapse-item :title="item.course_name" :name="index" v-for="(item,index) in courseTable">
					<div v-for="_item in item.chapter"
						style="display: flex;align-items: center;justify-content: space-between;height: 40px;">
						<div>{{_item.name}}</div>
						<div>{{_item.persent==0?'未学习':_item.persent==100?'已学完':'学习中'}}</div>
					</div>
				</el-collapse-item>
			</el-collapse>
		</el-card>

		<el-card shadow="never" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<h4>已报名培训</h4>
			</div>
			<el-table :data="tableData1" border class="table-wrap"
				:header-cell-style="{background:'#eef1f6',color:'#606266'}" style="width: 100%">
				<el-table-column prop="train_name" label="培训名称" align="center">
				</el-table-column>
				<el-table-column prop="order_status" label="培训状态" align="center">
					<template slot-scope="scope">
						{{scope.row.train_status==1?'报名中':scope.row.train_status==2?'进行中':'已结束'}}
					</template>
				</el-table-column>
				<el-table-column prop="address" label="支付方式" align="center">
					<template slot-scope="scope">
						{{scope.row.pay_type==1?'积分':scope.row.pay_type==2?'微信':'免费'}}
					</template>
				</el-table-column>
				<el-table-column prop="address" label="支付费用" align="center">
					<template slot-scope="scope">
						{{scope.row.pay_type==1?scope.row.score:scope.row.pay_type==2?scope.row.price:0}}
					</template>
				</el-table-column>
				<el-table-column prop="get_score" label="奖励积分" align="center">
					<template slot-scope="scope">
						{{scope.row.get_score?scope.row.get_score:0}}
					</template>
				</el-table-column>
			</el-table>
		</el-card>


		<el-card shadow="never" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<h4>购买记录</h4>
			</div>
			<el-tabs v-model="activeTab" @tab-click="handleClick">
				<el-tab-pane label="课程购买记录" name="first">
					<el-table :data="courseTable" border class="table-wrap"
						:header-cell-style="{background:'#eef1f6',color:'#606266'}"
						style="width: 100%;margin-bottom: 20px;" row-key="id" border default-expand-all
						:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
						<el-table-column prop="course_name" label="课程名称/章节名称" align="center">
						</el-table-column>
						<el-table-column prop="order_id" label="订单编号" align="center">
						</el-table-column>
						<el-table-column prop="score" label="支付积分数" align="center">
						</el-table-column>
						<el-table-column prop="create_time" label="购买时间" align="center">
						</el-table-column>
						<el-table-column prop="address" label="操作" align="center">
							<template slot-scope="scope">
								<div class="">
									<span class="operation-item"
										@click="$router.push('/course-order-detail?uuid='+scope.row.uuid)">查看</span>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane label="会员购买记录" name="second">
					<el-table :data="memberTable" border class="table-wrap"
						:header-cell-style="{background:'#eef1f6',color:'#606266'}"
						style="width: 100%;margin-bottom: 20px;" row-key="id" border default-expand-all
						:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
						<el-table-column prop="member_name" label="会员名称" align="center">
						</el-table-column>
						<el-table-column prop="name" label="支付方式" align="center">
							<template slot-scope="scope">
								{{scope.row.pay_type==1?'积分':'微信'}}
							</template>
						</el-table-column>
						<el-table-column prop="address" label="支付费用" align="center">
							<template slot-scope="scope">
								{{scope.row.pay_type==1?scope.row.score_cost:scope.row.price_cost}}
							</template>
						</el-table-column>
						<el-table-column prop="create_time" label="购买时间" align="center">
						</el-table-column>
						<el-table-column prop="address" label="购买类型" align="center">
							<template slot-scope="scope">
								{{scope.row.type==1?'首次升级':scope.row.type==2?'自动续费':scope.row.type==3?'手动升级':'手动续费'}}
							</template>
						</el-table-column>
						<el-table-column prop="address" label="操作" align="center">
							<template slot-scope="scope">
								<div class="">
									<span class="operation-item"
										@click="$router.push('/member-order-detail?uuid='+scope.row.uuid)">查看</span>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
			</el-tabs>
		</el-card>

		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			<el-button type="primary" style="width: 200px;" plain @click="goBack">返回</el-button>
		</el-card>


	</div>
</template>

<script>
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import {
		getUserDetail,
		getInvite,
	} from "@/api/user"
	import {
		getCourseOrderList,
		getMemberOrderList,
		getTrainOrderList
	} from "@/api/orders"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				inviteTable: [],
				inviteTotal: 0,
				activeTab: 'first',
				imgDomain,
				total: 0,
				page_size: 9,
				page_index: 1,
				doubaoList: [],
				num: 1,
				detailObject: {},
				detailUserId: '',
				selectedTabIndex: "all",
				activeName: '1',
				user_uuid: '',
				total1: 0,
				page_index1: 1,
				page_size1: 9,
				hisLists: [],
				memberTable: [],
				courseTable: [],
				tableData1: []
			};
		},
		components: {
			CommonPagination,
		},
		async mounted() {
			const uuid = this.$route.query.uuid
			this.user_uuid = uuid
			if (uuid) {
				this.getUserDetail(uuid);
				this.getInvite(uuid)
				this.getCourseOrderList(uuid)
				this.getMemberOrderList(uuid)
				this.getTrainOrderList(uuid)
			}
		},
		methods: {
			async getTrainOrderList(uuid) {
				let postData = {
					page_size: 9999,
					page_index: 1,
					user_uuid: uuid,
				};
				const {
					status,
					data
				} = await getTrainOrderList(postData);
				if (status !== 200) return;
				this.tableData1 = data.result.data;
			},
			async getMemberOrderList(uuid) {
				let postData = {
					page_size: 9999,
					page_index: 1,
					user_uuid: uuid,
				};
				const {
					status,
					data
				} = await getMemberOrderList(postData);
				if (status !== 200) return;
				this.memberTable = data.result.data;
			},
			async getCourseOrderList(uuid) {
				let postData = {
					page_size: 9999,
					page_index: 1,
					user_uuid: uuid,
				};
				const {
					status,
					data
				} = await getCourseOrderList(postData);
				if (status !== 200) return;
				this.courseTable = data.result.data;
			},
			async getInvite(uuid) {
				let postData = {
					page_size: 9999,
					page_index: 1,
					user_uuid: uuid,
				};
				const {
					status,
					data
				} = await getInvite(postData);
				if (status !== 200) return;
				this.inviteTable = data.result.data;
				this.inviteTotal = data.result.total
			},
			handlePageChange(page) {
				this.page_index = page
				this.getDoubao()
			},
			handlePageChange1(page) {
				this.page_index1 = page
				this.getAiApplicationHistoryList()
			},
			handleClick(tab, event) {
				if (tab.name == 'second') {
					this.getAiApplicationHistoryList()
				}
				if (tab.name == 'first') {
					this.getDoubao()
				}
			},
			async getDoubao() {
				let postData = {
					page_size: this.page_size,
					page_index: this.page_index,
					user_uuid: this.user_uuid
				};
				const {
					status,
					data
				} = await getDoubao(postData);
				if (status !== 200) return;
				this.doubaoList = data.result.data;
				this.total = data.result.total;
			},
			async getAiApplicationHistoryList() {
				// let postData = {
				// 	page_size: this.page_size1,
				// 	page_index: this.page_index1,
				// 	user_uuid: this.user_uuid
				// };
				// const {
				// 	status,
				// 	data
				// } = await getAiApplicationHistoryList(postData);
				// if (status !== 200) return;
				// this.hisLists = data.result.data;
				// this.total1 = data.result.total;
			},
			goBack() {
				this.$router.go(-1)
			},
			async getUserDetail(uuid) {
				const {
					data,
					status
				} = await getUserDetail({
					uuid: uuid
				});
				if (status === 200) {
					this.detailObject = data.result;
				}
			},
			handleClickBack() {
				this.$router.back(-1);
			},
			async disableUser() {
				let postData = {
					user_id: this.detailObject.user_id
				}
				const {
					status,
					data
				} = await disableUser(postData);
				if (status !== 200) return;
				await this.getUserDetail(this.detailObject.user_id);
			},

			async ableUser() {
				let postData = {
					user_id: this.detailObject.user_id
				}
				const {
					status,
					data
				} = await ableUser(postData);
				if (status !== 200) return;
				await this.getUserDetail(this.detailObject.user_id);
			},

		}
	};
</script>

<style lang="less" scoped>
	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}

	.operation-item {
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}

	::v-deep .el-descriptions-item__label {
		width: 15% !important;
	}

	::v-deep .el-descriptions-item__cell {
		color: #000;
	}
</style>